import { Component, OnInit, OnDestroy, PLATFORM_ID, Inject, Renderer2, ElementRef } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { WebsiteService } from 'src/app/_services/website.service';
import { LinkService } from '../../_services/langhfre.service';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { Title, Meta } from '@angular/platform-browser';
import { isPlatformBrowser, DOCUMENT } from '@angular/common';
//import { environment } from 'src/environments/environment';
// import { AmplitudeService } from 'src/app/_services/amplitude.service';
import * as $ from 'jquery';
import { Router } from '@angular/router';
//declare function ire(string,{}): any;
@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
})
export class HomeComponent implements OnInit, OnDestroy {
  contactToSalesForm: FormGroup;
  contactForm: FormGroup;
  formSection: boolean = true;
  thankSection: boolean = false;
  country: string;

  constructor(
    private toastr: ToastrService,
    private networkCall: WebsiteService,
    private fb: FormBuilder,
    private titleService: Title,
    private metaTagService: Meta,
    @Inject(PLATFORM_ID) private platformId: Object,
    private LinkService: LinkService,
    // public amplitudeService: AmplitudeService,
    private router: Router,
    private _renderer2: Renderer2, 
    private elementRef: ElementRef,
    private renderer: Renderer2,
    private el: ElementRef,
    @Inject(DOCUMENT) private _document: Document

  ) {
    this.contactForm = fb.group({
      'contactFormName': ['', Validators.required],
      'contactFormEmail': ['', Validators.compose([Validators.required, Validators.pattern(/^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/)])],
      'contactFormSubjects': ['', Validators.required],
      'contactFormMessage': ['', Validators.required],
      'contactphoneNo': ['', Validators.required],
      'NatureBusinessType': ['', Validators.required],
      'DesignationTypes': ['', Validators.required],
    });
  }
  email: any;

  ngOnInit() {
    this.titleService.setTitle('AI英文校正ツールTrinka |論文の英語修正を無料で');
    this.metaTagService.updateTag({ name: 'description', content: '学術論文やテクニカルライティングに特化したAI英文校正ツールTrinka（トリンカ）。オンラインで、文法やスペルだけでなく専門的な修正も迅速に提案します。' });
    this.metaTagService.updateTag({ name: 'keywords', content: '英文 校正,文法 チェック,英語 文法 チェック,文法 チェッカ,ー英文 チェッカー,英文 チェック,校正 英語,英文 校閲,文法 チェック 英語,英文 チェック 無料 サイト,英語 校正,英文 校正 英語,英文 チェック 無料,論文 校正,英文 校正 無料,英文 チェック サイト,英文 文法 チェック,gramamr checker, english grammar checker' });
    this.metaTagService.updateTag({ property: 'og:title', content: 'AI英文校正ツールTrinka |論文の英語修正を無料で' });
    this.metaTagService.updateTag({ property: 'og:description', content: '学術論文やテクニカルライティングに特化したAI英文校正ツールTrinka（トリンカ）。オンラインで、文法やスペルだけでなく専門的な修正も迅速に提案します。' });
    this.metaTagService.updateTag({ property: 'og:url', content: 'https://www.trinka.ai/jp/' });
    this.metaTagService.updateTag({ property: 'og:type', content: 'website' });
    this.metaTagService.updateTag({ property: 'og:image', content: 'https://www.trinka.ai/assets/images/Trinka.jpg' });
    this.metaTagService.updateTag({ name: 'language', content: 'ja-jp' });
    this.metaTagService.updateTag({ name: 'twitter:title', content: 'AI英文校正ツールTrinka |論文の英語修正を無料で' });
    this.metaTagService.updateTag({ name: 'twitter:description', content: "学術論文やテクニカルライティングに特化したAI英文校正ツールTrinka（トリンカ）。オンラインで、文法やスペルだけでなく専門的な修正も迅速に提案します。" });
    this.metaTagService.updateTag({ name: 'twitter:image', content: 'https://www.trinka.ai/assets/images/Trinka.jpg' });
    this.LinkService.addTag({ rel: 'canonical', href: 'https://www.trinka.ai/jp/' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'x-default', href: 'https://www.trinka.ai'});
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'en-us', href: 'https://www.trinka.ai'});
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-cn', href: 'https://trinka.enago.cn' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-tw', href: 'https://www.trinka.ai/tw/' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ja-jp', href: 'https://www.trinka.ai/jp/' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ko-kr', href: 'https://www.trinka.ai/kr/' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'es-es', href: 'https://www.trinka.ai/es/' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'pt-pt', href: 'https://www.trinka.ai/pt/' });
    // this.amplitudeService.logAmplitude('home_page_view', {});
    let script = this._renderer2.createElement('script');
    script.type = `application/ld+json`;
    script.text = `{"@context":"https://schema.org/", "@type":"Product", "name":"Trinka AI Grammar Checker","image":"https://www.trinka.ai/assets/images/trinka-logo.png","description":"Improve your writing and grammar with AI writing assistant! Trinka polishes your writing with AI editing & proofreading for clear, concise, & impactful communication. Try for FREE!","brand":{"@type":"Brand","name":"Trinka"},"sku":"","aggregateRating": {"@type":"AggregateRating","ratingValue":"4.9","bestRating":"5","worstRating":"1","ratingCount":"
    228141"},"review": [{"@type":"Review","name":"Best Grammar Checker","reviewBody":"First, I love Trinka. Congratulations on developing something that extensively aids editing, especially critical grammar conventions and word count reductions.","reviewRating": {"@type":"Rating","ratingValue":"4.9","bestRating":"5","worstRating":"1"},"datePublished":"2021-07-24","author": {"@type":"Person", "name":"James Smith"},"publisher": {"@type":"Organization", "name":"Trinka AI"}},{"@type":"Review","name":"Best Grammar Checker","reviewBody":"Writing texts with correct English grammar and style is not an easy task for people who speak other languages. Sometimes you cannot find little mistakes in your document without help and moreover for academic writing. I tried Trinka AI as a tool of automatic correction and was quite glad with the suggested corrections and the feedback. With the feedback you understand why the suggested change must be taken into account.","reviewRating": {"@type":"Rating","ratingValue":"4.9","bestRating":"5","worstRating":"1"},"datePublished":"2022-03-04","author": {"@type":"Person", "name":"Rosa Diaz Sandoval"},"publisher": {"@type":"Organization", "name":"Trinka AI"}},{"@type":"Review","name":"Best Grammar Checker","reviewBody":"I just wanted to say thank you for such a great and free service, all the other grammar checkers and writing assistants I have tried don’t have nearly the depth of features let alone all available on a free subscription. As a student with little income available I am extremely grateful that unlike all others companies you don’t limit features on the free plan. This is a fantastic product and given the income I would definitely upgrade to the premium. I've let all my fellow students know about Trinka as it is seriously a life saver.","reviewRating": {"@type":"Rating","ratingValue":"4.9","bestRating":"5","worstRating":"1"},"datePublished":"2022-07-22","author": {"@type":"Person", "name":"Jesse Rumball-Smith"},"publisher": {"@type":"Organization", "name":"Trinka"}}]}
    `;

    this._renderer2.appendChild(this._document.head, script);
    //ire('identify', {'customerId':'', customerEmail: '', customProfileId: this.generateGuid()});
  }
  
  ngAfterViewChecked(): void {
    this.setSliderPosition();
  }

  ngOnDestroy() {
    if (isPlatformBrowser(this.platformId)) {
      //document.getElementById('main_header').classList.remove('homepageHeader');
    }
  }

  onTabClick(event: any): void {
    this.setSliderPosition();
  }

  scrollToElementWithOffset(id: string, offset: number = 0) {
    const element = document.getElementById(id);
    if (element) {
      const yOffset = element.getBoundingClientRect().top + window.pageYOffset - offset;
      window.scrollTo({ top: yOffset, behavior: 'smooth' });
    }
  }

  private setSliderPosition(): void {
    const tabs = this.elementRef.nativeElement.querySelectorAll('#tile-1 .nav-pills a');
    const activeTab = this.elementRef.nativeElement.querySelector('#tile-1 .nav-pills .active');

    if (activeTab) {
      const tabsContainer = this.elementRef.nativeElement.querySelector('#tile-1 .nav-pills');
      const position = activeTab.offsetLeft - tabsContainer.offsetLeft;
      const width = activeTab.offsetWidth;

      const slider = this.elementRef.nativeElement.querySelector('#tile-1 .slider');
      slider.style.left = position + 'px';
      slider.style.width = width + 'px';
    }
  }

  // private loadScript(scriptUrl: string): void {
  //   const script = this._renderer2.createElement('script');
  //   script.type = 'text/javascript';
  //   script.src = scriptUrl;
  //   script.async = true;
  //   this._renderer2.appendChild(this.el.nativeElement, script);
  // }

  // initializeMoEngage(): void {
  //   console.log('initializeMoEngage is getting called!');
  //   const script_mo = this.renderer.createElement('script');
  //   script_mo.type = 'text/javascript';
  //   script_mo.text = `
  //     Moengage = moe({
  //       app_id: "EQ1PHJBKXGBUXRSIOCYPHP5B"
  //     });
  //     Moengage.call_web_push({
  //       "soft_ask": true,
  //       "main_class": "moe-main-class",
  //       "allow_class": "moe-allow-class",
  //       "block_class": "moe-block-class"
  //     });
  //     // Additional configuration or calls if needed
  //   `;
  //   this.renderer.appendChild(document.head, script_mo);
  //   console.log('MoEngage initialized successfully!');
  // }

  
  

}